import some from "lodash/some";
export default (data, interval) => !interval ||
    some(data, d => d.timestamp && interval && d.timestamp >= interval.from && d.timestamp <= interval.to);
